export default {
      id: "location-icon-usage",
      viewBox: "0 0 22 23",
      url: __webpack_public_path__ + "ico/gefera/sprite.svg#location-icon",
      toString: function () {
        return this.url;
      }
    }